import { queryOptions } from '@tanstack/react-query';

import { BRAND_SERVICE_VERSION_HEADERS } from '@/constants/environments';
import apiClient from '@/constants/http';
import { Logger } from '@/utils/logging';

import type { WaitlistDetailResponse } from './types';

async function getWaitlistDetail(
  waitlistCustomerId: string,
): Promise<WaitlistDetailResponse> {
  try {
    const { data } = await apiClient.get<WaitlistDetailResponse>(
      `/v1/customer/waiting-list/${waitlistCustomerId}`,
      {
        params: {
          include: 'customer,services',
        },
        headers: BRAND_SERVICE_VERSION_HEADERS,
      },
    );

    return data;
  } catch (error) {
    Logger.error('getWaitlistDetail failed', { error, waitlistCustomerId });
    throw error;
  }
}

export const waitlistDetailQueryOptions = (waitlistCustomerId: string) =>
  queryOptions({
    queryKey: ['waitlistDetail', waitlistCustomerId],
    queryFn: () => getWaitlistDetail(waitlistCustomerId),
    enabled: !!waitlistCustomerId,
  });
